import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Fuentes variables (ver ADR-006 y DESIGN-SYSTEM §2):
//   - Cormorant Garamond — serif editorial primaria para títulos (display, h1-h3).
//   - Cinzel — alternativa display condensed (--font-display-condensed),
//     conservada para monogramas y casos puntuales.
//   - Montserrat — sans-serif para cuerpo y UI.
// fontsource carga los archivos woff2 + declara @font-face automáticamente.
import '@fontsource-variable/cormorant-garamond';
import '@fontsource-variable/cinzel';
import '@fontsource-variable/montserrat';

import App from './App.tsx';
import './index.css';
// Sentry opt-in: inicializa ANTES de createRoot para capturar errores tempranos
// (mount, providers). Si VITE_SENTRY_DSN está vacío es no-op.
import { initSentry } from './lib/sentry';

initSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
